module.exports = __webpack_public_path__ + "img/office-revenue.1e9852aa.png";